<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">
    <div class="card shadow-0 border-0" style="background-color:inherit">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <form id="createContactForm" name="createContactForm">
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('first_name')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input required v-model="firstname" type="text" id="txtfirstname" v-bind:placeholder="$t('first_name')" maxlength="200" name="firstname" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('last_name')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="lastname" type="text" id="txtlastname" v-bind:placeholder="$t('last_name')" maxlength="200" name="lastname" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('email')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="email" type="email" id="txtemail" v-bind:placeholder="$t('email')" maxlength="200" name="email" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('phone')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="phone" type="text" id="txtphone" v-bind:placeholder="$t('phone')" maxlength="200" name="phone" class="form-control" />
                </div>
              </div>
              <!--<div class="row mt-3">
    <div class="col-lg-12 custom-form-label">
      {{$t('address')}}
    </div>
  </div>
  <div class="form-group row mt-1">
    <div class="col-lg-12">
      <input type="text" onclick="initDefaultAutoCompleteLocations(this);" name="address" v-bind:placeholder="$t('type_address')" value="" id="txtaddress" onfocus="" class="form-control input-lg">
    </div>
  </div>-->
              <div class="row form-group mt-3">
                <div class="col-lg-12">
                  <location-autocomplete ref="autocompleteLocation" @text_changed="adressChanged" @changed="adressChanged"></location-autocomplete>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('username')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="username" type="text" id="txtusername" v-bind:placeholder="$t('username')" maxlength="200" name="role" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('role')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="role" type="text" id="txtrole" v-bind:placeholder="$t('role')" maxlength="200" name="role" class="form-control" />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('roledescription')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="roledescription" type="text" id="txtroledescription" v-bind:placeholder="$t('roledescription')" maxlength="200" name="roledescription" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('skype')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="skype" type="text" id="txtskype" v-bind:placeholder="$t('skype')" maxlength="200" name="skype" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('facebook')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="facebook" type="text" id="txtfacebook" v-bind:placeholder="$t('facebook')" maxlength="200" name="facebook" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('linkedin')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <input v-model="linkedin" type="text" id="txtlinkedin" v-bind:placeholder="$t('linkedin')" maxlength="200" name="linkedin" class="form-control" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('notes')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <textarea class="form-control" v-bind:placeholder="$t('notes')" v-model:value="notes" id="txtnotes"></textarea>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-12 custom-form-label">
                  {{$t('procedure_category')}}
                </div>
              </div>
              <div class="form-group row mt-1">
                <div class="col-lg-12">
                  <select class="form-control" data-fouc id="selectcontactcategory" v-select='selected' v-on:change="onChange">
                    <option value="-1" style="">{{$t('select_category')}}</option>
                    <option v-for="category in categories" v-bind:value="category.CategoryId">
                      {{ category.Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mt-3" v-if="selected == -2">
                <div class="col-lg-12 custom-form-label">
                  {{$t('new_category_name')}}
                </div>
              </div>
              <div class="form-group row" v-if="selected == -2">
                <div class="col-lg-12">
                  <input-text required type="text" v-bind:placeholder="$t('enter_new_category_name')" v-model="categoryname" class="form-control"></input-text>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-12">
                  <button @click="createContact" type="button" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{ $t('save') }}</button>
                </div>
              </div>
              <div class="col-12">
                <div v-if="msg != null && msg != ''" class="col-12 alert shadow-0 alert-success border-0 upload-error-message mt-3" role="alert">
                  <ul>
                    <li class="col-12">
                      {{ msg }}
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let msg = "";
  var categories = [];
  export default {
    name: "add-contact",
    components: {

    },
    props: {
      contactId: {
        type: Number,
        default: -1
      },
    },
    data() {
      return {
        msg: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        address: "",
        lat: '',
        lng: '',
        //adress: '',
        role: "",
        notes: "",
        roledescription: "",
        skype: "",
        facebook: "",
        linkedin: "",
        categories,
        selected: 0,
        categoryname: "",
        username: "",
        //categoryId:-1,
      };
    },
    methods: {

      restForm() {
        this.username = "";
        this.firstname = '';
        this.lastname = '';
        this.email = '';
        this.phone = '';
        this.address = '';
        this.role = '';
        this.notes = '';
        this.roledescription = '';
        this.skype = '';
        this.facebook = '';
        this.linkedin = '';
        this.selected = 0;
        this.categoryname = '';
        $("#txtaddress").val("");
        $("#selectcontactcategory").val(-1);
        $("#selectcontactcategory").trigger('change');
        this.msg = '';
        this.lat = '';
        this.lng = '';
        $("#AutoCompletedLocation").val('');
      },
      adressChanged(address, lat, lng) {
        this.address = address;
        this.lat = lat;
        this.lng = lng;
      },
      async createContact() {
        if (!$('#createContactForm').valid())
          return false;

        var lg = this.lng;
        var lt = this.lat;
        if (lg == '') {
          lg = null;
        }
        if (lt == '') {
          lt = null;
        }
        var request = {
          ContactId: this.contactId, FirstName: this.firstname, LastName: this.lastname, Email: this.email,
          Phone: this.phone,
          Address: this.address,//$('#txtaddress').val(),
          Role: this.role,
          Notes: this.notes,
          Roledescription: this.roledescription,
          Skype: this.skype,
          Facebook: this.facebook,
          Linkedin: this.linkedin,
          CategoryId: this.selected,
          CategoryName: this.categoryname,
          Longitude: lg, Lattitude: lt,
          username: this.username,
        };

        try {
          var response = await this.$http.post(
            '/api/Contacts/v1',
            request
          ).then(async response => {
            var rep = response.data;
            if (rep.ErrorMsg != undefined) {
              this.msg = rep.ErrorMsg;
            } else {
              this.restForm();
              this.$emit('event-refresh-contact');
              if (request.CategoryId == -2) {
                this.loadCategories(response.data.CategoryId);
              }
            }
          });

        } catch (err) {
          alert(err);
        }
      },
      onChange(event) {
        this.selected = event.target.value;
        //this.categoryId = parseInt(event.target.value);
      },
      loadCategories(id) {
        try {
          var url = '/api/Contacts/v1/Categories';
          this.$http.get(url).then(async response => {
            var cats = response.data;
            cats.push({ Name: this.$t('add_category'), CategoryId: -2 })
            Vue.set(this, "categories", cats);
            this.$forceUpdate();

            setTimeout(function () {
              if (id != null) {
                $("#selectcontactcategory").select2();
                $("#selectcontactcategory").val(id);
                $("#selectcontactcategory").trigger('change');
              }
            }, 100)

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async getContact(contactId) {
        try {
          this.$http.get(`/api/Contacts/v1/${contactId}`).then(async response => {
            var contact = response.data;
            this.firstname = contact.FirstName;
            this.lastname = contact.LastName;
            this.email = contact.Email;
            this.phone = contact.Phone;
            //$('#txtaddress').val(contact.Address);
            this.lat = contact.Lattitude;
            this.lng = contact.Longitude;
            this.address = contact.Address;
            this.username = contact.UserName;
            this.$refs.autocompleteLocation.setValue(contact.Address, contact.Lattitude, contact.Longitude);


            this.role = contact.Role;
            this.notes = contact.Notes;
            this.roledescription = contact.Roledescription;
            this.skype = contact.Skype;
            this.facebook = contact.Facebook;
            this.linkedin = contact.Linkedin;
            this.selected = contact.CategoryId;
            if (contact.CategoryId > 0) {
              $("#selectcontactcategory").val(contact.CategoryId);
              $("#selectcontactcategory").trigger('change');
            } else {
              $("#selectcontactcategory").val(-1);
              $("#selectcontactcategory").trigger('change');
            }
            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      contactId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getContact(newVal);
        }
      }
    },
    mounted() {
      _componentValidation('#createContactForm');
      this.loadCategories();
      if (this.contactId > 0) {
        this.getContact(this.contactId);
      }
      $("#selectcontactcategory").select2();
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/contact/add-contact.vue